<template>
  <!-- eslint-disable-next-line vue/no-unused-vars -->
  <router-view >
    <component :is="resolveComponent()" />
  </router-view>
</template>

<script>
import DownloadApp from './components/DownloadApp.vue';
import NonDownload from './components/NonDownload.vue';

export default {
  name: 'App',
  components: {
    DownloadApp,
    NonDownload,
  },
  methods: {
    resolveComponent() {
      console.log(window.location.pathname, '------', window.location.search, '------');
      const path = window?.location?.pathname?.toLowerCase();
      const queryString = window?.location?.search?.toLowerCase();
      console.log('Resolved path:', path, 'Query string:', queryString);

      // Check for query parameters
      if (queryString.includes('?ref')) {
        return NonDownload;
      }
      else if (queryString.includes('?path')) {
        return NonDownload;
      }

      // Define your dynamic routes here (similar to your route array)
      const validRoutes = [
        '/',
        // Ancestry screens
        '/whatsonbell',
        '/home',
        '/trees',
        '/stories',
        '/communitiesscreentab',
        '/creatediscussions',
        '/createpoll',
        '/profile',
        '/feedback',
        '/faq',
        '/aboutus',
        '/privacy',
        '/accountdna',
        '/imeuswesearch',
        '/myorders',
        '/login',
        '/signup',
        '/communitydetails',
        '/story',
        // Astrology screens
        '/astrohome',
        '/horoscope',
        '/reports',
        '/matchmaking',
        '/panchang',
        '/consultation',
        '/astroorderhistory',
        '/wallethistory',
        '/livestreamlisting',
        '/aiastrologers',
        '/anvayaai',
        '/services',
        '/walletrecharge',
        '/weeklyhoroscope',
        '/whoami',
        '/livesessioncalls',
        '/subscriptions',
      ];
      console.log('Known route:', path);
      
      // Check for CommunityDetails routes (both with and without ID)
      if (path === '/communitydetails' || path.startsWith('/communitydetails/')) {
        return NonDownload;
      }

      // Check for mylife routes
      if (path === '/mylife' || path.startsWith('/mylife/')) {
        return NonDownload;
      }

      // Check for astroorderhistory routes (with optional tab sub-path)
      if (path === '/astroorderhistory' || path.startsWith('/astroorderhistory/')) {
        return NonDownload;
      }

      // Check for orderhistory routes (My Orders, with optional tab sub-path:
      // reports/chat/call/gift)
      if (path === '/orderhistory' || path.startsWith('/orderhistory/')) {
        return NonDownload;
      }

      // Check for astroprofile routes
      if (path.startsWith('/astroprofile/')) {
        return NonDownload;
      }

      if (path === '/prarthana' || path.startsWith('/prarthana/')) {
        return NonDownload;
      }
      // Render NonDownload for known routes
      if (validRoutes.includes(path)) {
        return NonDownload;
      } // Unknown route (404)
    },
  },
};
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>